import { Variants } from '../types/variant';

export const angioVariants = {
  angio: {
    name: 'Angiologie',
    status: 'beta',
    description:
      'Questionnaire pour les patients en angiologie. Couvre les motifs, les antécédents personnels et familiaux du patient ainsi que la prévention.',
    speciality: 'ANGIO',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'ANGIOLOGY',
    initialQuestions: [],
    pages: {
      CONSULTATION: { title: 'Administratif', sections: ['CONTEXTE'] },
      COMPLAINTS: { title: 'Motifs', sections: ['MOTIF'] },
      VASCULAR_HISTORY: {
        title: 'Antécédents vasculaires',
        sections: ['ANTECEDENTS_VASCULAIRES'],
      },
      CARDIAC_HISTORY: {
        title: 'Antécédents cardiaques',
        sections: ['ANTECEDENTS_CARDIAQUES'],
      },
      OTHER_HISTORY: {
        title: 'Vos autres problèmes de santé personnels',
        sections: ['ANTECEDENTS_AUTRES'],
      },
      FAMILIAL_HISTORY: {
        title: 'Vos antécédents familiaux',
        sections: ['ANTECEDENTS_FAM'],
      },
      CARDIOVASC_RISK: {
        title: 'Votre risque cardiovasculaire',
        sections: ['CV_RISK'],
      },
      ALLERGIES: {
        title: 'Vos allergies et intolérances',
        sections: ['ALLERGIES'],
      },
      TREATMENTS: {
        title: 'Vos traitements actuels',
        sections: ['TREATMENT'],
      },
      COMPLAINTS_FU: {
        title: 'Motifs de consultation',
        sections: [
          'MOTIF_FOLLOWUP_ART',
          'MOTIF_QOL_ART',
          'MOTIF_FOLLOWUP_SUITE_ART',
          'MOTIF_FOLLOWUP',
          'MOTIF_QOL',
          'MOTIF_FOLLOWUP_SUITE',
          'MOTIF_FOLLOWUP_PLAIE',
          'MOTIF_SUITE_PLAIE_VEIN',
          'MOTIF_SUITE_PLAIE_ART',
          'MOTIF_FOLLOWUP_LYMPH',
          'MOTIF_SUITE_LYMPH_PLAIE',
          'MOTIF_SUITE_LYMPH_VEIN',
          'MOTIF_SUITE_LYMPH_ART',
        ],
      },
      PREVENTION: {
        title: 'Prévention',
        sections: ['PREVENTION'],
      },
      CONCLUSION: { title: 'Conclusion', sections: ['RECAP'] },
    },
    initialAssertions: [
      "[Message: #‹]-(06.a_lieu_emission)->[Lieu]-(01.DESCR)->[Salle d'Attente]-(PART_OF)->[Cabinet Médical: #c]",
      '[Médecin: #z‹]-(a_spécialité)->[Angiologie]',
    ],
    options: ['ALERTES'],
    visitMotivesSection: 'Examen demandé',
  },
} satisfies Variants;
